export const extendDataLoader = {
    wrapper: () => ({
        height: 'calc(100% - 64px)',
    }),
};
